/** Angular */
import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
/** Services */
import { BydFeatureFlagService } from '../services/byd-feature-flag.service';
/**
 * The feature toggles directive in Angular applications.
 *
 * @example <ng-container *featureFlags="'feat1'">...</ng-container>
 *
 *          <ng-container *featureFlags="['feat1', 'feat2']">...</ng-container>
 */
@Directive({
  selector: '[bydFeatureFlags]',
})
export class BydFeatureFlagDirective<T> implements OnInit {
  /**
   * The Feature flags key(s) from the directive
   */
  @Input() bydFeatureFlags: string | string[];

  /**
   * The else block TemplateRef instance.
   *
   * @example
   * <ng-container *featureFlag="['A_Flag'];else elseTemplateBlock">A_Template</ng-container>
   * <ng-template #elseTemplateBlock>elseTemplateBlock</ng-template>
   */
  @Input() bydFeatureFlagsElse: TemplateRef<T>;

  /**
   * Creates an instance of BydFeatureFlagDirective.
   *
   * @param templateRef the embedded template that can be used to instantiate embedded views
   * @param viewContainerRef the container where one or more views can be attached to a component
   * @param bydFeatureFlagService check the feature flag(s) state
   */
  constructor(
    private templateRef: TemplateRef<T>,
    private viewContainerRef: ViewContainerRef,
    private bydFeatureFlagService: BydFeatureFlagService<T>
  ) {}

  /**
   * Instantiates the embedded view and inserts it into the container based on the Feature Flags.
   */
  ngOnInit(): void {
    if (this.bydFeatureFlagService.hasFlags(this.bydFeatureFlags)) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else if (this.bydFeatureFlagsElse) {
      this.viewContainerRef.createEmbeddedView(this.bydFeatureFlagsElse);
    } else this.viewContainerRef.clear();
  }
}
